export default __webpack_public_path__ + "static/media/logo.b714e7ab.png";